import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  list({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentProfit/findAgentProfitList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentProfit/exportList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAgentProfit({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentProfit/getAgentProfit`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportAgentProfit({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentProfit/exportAgentProfit`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findAgentProfitInfoList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentProfit/findAgentProfitInfoList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findOrderChildren({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentProfit/findOrderChildren`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentProfit/exportOrder`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findCardRecordList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentProfit/findCardRecordList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportCardRecordList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentProfit/exportCardRecordList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findRevenueList({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentProfit/findRevenueList`, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findRevenueStatisticList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentProfit/findRevenueStatisticList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findCanWithdraw({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`agentProfit/findCanWithdraw`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  queryBalance({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/queryBalance`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  queryBalancePerson({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/queryBalancePerson`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  queryBalanceOrg({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/queryBalanceOrg`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllBindCard({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/getAllBindCard`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllBindCardPerson({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/getAllBindCardPerson`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllBindCardOrg({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/getAllBindCardOrg`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  withdrawApply({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`yunBind/withdrawApply`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  enterPay({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`yunBind/enterPay`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findAllWithdrawal({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentProfit/findAllWithdrawal`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
